// extracted by mini-css-extract-plugin
module.exports =  {"root":"bTNpvGqdOW2AHYJwF3UC","statistics":"UoQquyebeXhzbNGihwlx","header":"fMnh2wFG7599D1TVWHwj","labelRow":"nS7FItoSHtN9wIhjxauJ","statusIcon":"VgA0xDAd3kcvvc69GTZl"};